// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2948 ? "bf1a185a" : chunkId) + "." + {"886":"6fcb9e38a06fd17c","2948":"fb783ef90a8fa987","4023":"7036ae9260fda3f4","6549":"5b011331b4cf1f90","9597":"53c48b02d91ec86c"}[chunkId] + ".js";
};